const l = {
  name: "CheckmarkCircleSmall",
  dimensions: { width: 18, height: 18 },
  content: `
    <g fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 9C11 7.89543 10.1046 7 9 7C7.89543 7 7 7.89543 7 9C7 10.1046 7.89543 11 9 11C10.1046 11 11 10.1046 11 9Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9Z" fill="currentColor"/>
    </g>
  `
};
export {
  l as CheckmarkCircleSmall
};
